import { BoxProps, Box } from "@hightouch/htui";

export function SidebarOpenIcon(props: BoxProps) {
  return (
    <Box
      as="svg"
      xmlns="http://www.w3.org/2000/svg"
      width="20ox"
      height="20ox"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <Box
        as="path"
        fill="currentColor"
        fillRule="evenodd"
        d="M14.6 3c1.103 0 1.991-.001 2.709.058.728.06 1.368.185 1.96.487a5.002 5.002 0 0 1 2.186 2.185c.302.593.428 1.233.487 1.961.059.718.058 1.606.058 2.71V13.6c0 1.103.001 1.991-.058 2.709-.06.728-.185 1.368-.487 1.96a5.003 5.003 0 0 1-2.185 2.186c-.593.302-1.233.428-1.961.487-.718.059-1.606.058-2.71.058H9.4c-1.103 0-1.991.001-2.709-.058-.728-.06-1.368-.185-1.96-.487a5.002 5.002 0 0 1-2.186-2.185c-.302-.593-.428-1.233-.487-1.961C1.999 15.59 2 14.703 2 13.599V10.4c0-1.103-.001-1.991.058-2.709.06-.728.185-1.368.487-1.96A5.002 5.002 0 0 1 4.73 3.544c.593-.302 1.233-.428 1.961-.487C7.41 2.999 8.297 3 9.401 3H14.6ZM9 5.001v13.997l.4.002h5.2c1.136 0 1.929 0 2.545-.05.606-.05.954-.143 1.217-.277a3 3 0 0 0 1.31-1.31c.135-.264.228-.612.277-1.218C20 15.53 20 14.736 20 13.6v-3.2c0-1.136 0-1.929-.05-2.546-.05-.605-.143-.953-.277-1.216a3 3 0 0 0-1.31-1.31c-.264-.135-.612-.228-1.218-.277C16.53 5 15.736 5 14.6 5H9.4l-.4.001Zm-2.146.05c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.31 1.31c-.135.264-.228.612-.277 1.217C4 8.471 4 9.264 4 10.4v3.2c0 1.136 0 1.929.05 2.545.05.606.143.954.277 1.217a3 3 0 0 0 1.31 1.31c.264.135.612.228 1.217.277.048.004.096.005.146.008V5.042c-.05.003-.098.005-.146.009Z"
        clipRule="evenodd"
      />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m15.5 10-2 2 2 2"
        opacity={0}
        transitionProperty="opacity"
        transitionDuration="fast"
        transitionTimingFunction="easeOutQuad"
        _groupHover={{
          opacity: 1,
        }}
        _groupFocusWithin={{
          opacity: 1,
        }}
      />
    </Box>
  );
}
